import gql from 'graphql-tag';

export const GET_STOCKTAKES_COUNT = gql`
	query (
		$filter: StocktakeCountFilter
	) {
		countStocktakes(
			filter: $filter,
		)
	}
`;
